export const CREATE_REWARD_REQUEST = '@reward/CREATE_REWARD_REQUEST';
export const CREATE_REWARD_SUCCESS = '@reward/CREATE_REWARD_SUCCESS';
export const UPDATE_REWARD_REQUEST = '@reward/UPDATE_REWARD_REQUEST';
export const UPDATE_REWARD_SUCCESS = '@reward/UPDATE_REWARD_SUCCESS';
export const FAILURE = '@reward/FAILURE';
